import React from "react";
import { motion } from "framer-motion";
import { Flag, Check } from "lucide-react";

export default function Milestones({ milestones = [] }) {
  if (!milestones.length) return null;
  return (
    <div className="card p-6 sm:p-7" data-testid="forecast-milestones">
      <h2 className="text-xl font-bold tracking-tight text-ink mb-1">Forecast milestones</h2>
      <p className="text-sm text-ink-2 mb-5">Each milestone is a set of achievable actions.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {milestones.map((m, i) => (
          <motion.div key={m.label} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
            className="rounded-2xl p-5 border" style={{ borderColor: m.reached ? "rgba(147,192,32,.4)" : "#E7E8E4", background: m.reached ? "rgba(147,192,32,.06)" : "#fff" }}
            data-testid={`milestone-${i}`}>
            <div className="flex items-center justify-between">
              <span className="grid place-items-center w-8 h-8 rounded-lg" style={{ background: m.reached ? "var(--grad-green)" : "#F1F2EE" }}>
                {m.reached ? <Check size={16} color="#fff" strokeWidth={2.5} /> : <Flag size={15} strokeWidth={2} style={{ color: "#6B6E62" }} />}
              </span>
              <span className="text-xs font-bold" style={{ color: m.reached ? "#5F8213" : "#6B6E62" }}>{m.reached ? "Within reach" : `${m.actions_remaining} action${m.actions_remaining > 1 ? "s" : ""}`}</span>
            </div>
            <p className="font-bold text-ink mt-3 tracking-tight">{m.label}</p>
            <p className="text-sm text-ink-2 mt-0.5">{m.actions_remaining} action{m.actions_remaining > 1 ? "s" : ""} remaining</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
